import { render, staticRenderFns } from "./onlinesetting.vue?vue&type=template&id=c16a3840&"
import script from "./onlinesetting.vue?vue&type=script&lang=ts&"
export * from "./onlinesetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports